import { compileFlow } from '../../simpleFlow/compileFlow';
export const parallelAtom = {
  id: 'uicore:parallel',
  name: '并行',
  category: '逻辑',
  desc: '',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'enableParallel',
      title: '并行',
      type: 'boolean',
      default: true
    }, {
      id: 'steps',
      type: 'array',
      title: '',
      'uc:allowExpr': false,
      'uc:allowReset': false,
      items: {
        type: 'object'
      },
      ui: {
        type: 'uicore:ParallelFlowList'
      },
      default: []
    }, {
      id: 'flowStatePass',
      title: '将内部的flowState传递至外部',
      type: 'boolean',
      default: true,
      hidden: true
    }]
  },
  paramsFormComponents: [
    // 已经迁移到 designerComponents 里面去了
  ],
  execute: async (ctx, params) => {
    // 收集每个flow返回的flowState
    let states = {};
    if (params.enableParallel) {
      const promiseList = params.steps.map(step => {
        const execute = compileFlow({
          steps: [step]
        }, ctx);
        return execute(ctx);
      });
      const resList = await Promise.all(promiseList);
      resList.forEach(res => {
        states = {
          ...states,
          ...(res === null || res === void 0 ? void 0 : res.state)
        };
      });
      return states;
    }
    // 直接串行
    const execute = compileFlow({
      steps: params.steps
    }, ctx);
    const res = await execute(ctx);
    return res === null || res === void 0 ? void 0 : res.state;
  }
};
//# sourceMappingURL=parallelAtom.js.map
